import { Component, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { PartnerSettingsMenuLevel3Enum } from '../../partner-settings-root/partner-settings-root.component';

@Component({
    selector: 'partnet-settings-update-legal-document',
    templateUrl: './partnet-settings-update-legal-document.component.html',
    styleUrls: ['./partnet-settings-update-legal-document.component.scss']
})

export class PartnerSettingsUpdateLegalDocumentsComponent {
    constructor(private messageService: MessageService) { }

    @Input()
    public visible: boolean = false;

    @Input()
    public activeDocumentItem: PartnerSettingsMenuLevel3Enum = PartnerSettingsMenuLevel3Enum.None;

    @Input()
    public onHide: () => void = () => { };

    public documentTypeEnum = PartnerSettingsMenuLevel3Enum;

    public loading: boolean = false;

    public cancel() {
        this.onHide();
    }
}
